module.exports = __webpack_public_path__ + "img/shadforth_logo.0975ef3e.png";